import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { computed, shallowRef } from 'vue';
import { kebabCase } from 'lodash-es';
import { useFacet } from '~/composables/_next/useFacet';
import { useAttraqtSearch } from '~/composables/attraqt/useAttraqtIntegration';
import { useSearchFacets } from '@/composables/_next/useSearchFacets';
import { useGetTranslations } from '@/composables/useGetTranslations';
import { useUser } from '~/composables/_next/useUser';
import { getVariants } from '~/helpers/productCardMethods';
import { isAllProductVariantsOOS } from '~/utils/ProductAvailability';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useSearchProductsStore() {
  var _useUser = useUser(),
    user = _useUser.user;
  var _useFacet = useFacet('searchResults'),
    productResults = _useFacet.result,
    search = _useFacet.search;
  var _useAttraqtSearch = useAttraqtSearch('attraqtSearchResults'),
    attraqtResult = _useAttraqtSearch.result,
    attraqtSearch = _useAttraqtSearch.search;
  var _useGetTranslations = useGetTranslations(),
    translate = _useGetTranslations.translate;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var _useSearchFacets = useSearchFacets(),
    facets = _useSearchFacets.facets;
  var route = useRoute();
  var _usePagination = usePagination(),
    currentPage = _usePagination.currentPage;
  var searchData = useState('search-data-products', function () {
    return shallowRef(null);
  });
  var productSorting = useState('search-sorting-products', function () {
    return null;
  });
  var productPagination = useState('search-pagination-products', function () {
    return null;
  });
  var productFacets = useState('search-facets-products', function () {
    return null;
  });
  var commercetoolsData = useState('search-products-commercetools-data', function () {
    return shallowRef(null);
  });
  var priceFilter = computed(function () {
    var minPrice = route.query['min-price'];
    var maxPrice = route.query['max-price'];
    var result = '';
    if (minPrice) result += " AND price>=".concat(minPrice * 100);
    if (maxPrice) result += " AND price<=".concat(maxPrice * 100);
    return result;
  });

  /**
   * The list of searchCategories. Only updates when the `term` of the search changes.
   */
  var productCategories = useState('search-categories', function () {
    return null;
  });
  function searchProducts(_x) {
    return _searchProducts.apply(this, arguments);
  }
  /**
   * Computes the sorted list of products based on the slugs and variant availability.
   * @returns {Array} Sorted array of product variants based on the search data and availability.
   */
  function _searchProducts() {
    _searchProducts = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(forcedSort) {
      var _productSorting$value, _route$params$term, _searchData$value2, _searchData$value2$in, _searchData$value4, _searchData$value4$da, _searchData$value4$da2;
      var oldSort, sortLabel, sortFacet, newProductPagination, _searchData$value3, _searchData$value3$da, _searchData$value3$da2, slugs, _user$value, _user$value$customerG;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            oldSort = (_productSorting$value = productSorting.value) === null || _productSorting$value === void 0 ? void 0 : _productSorting$value.selected;
            sortLabel = forcedSort !== null && forcedSort !== void 0 ? forcedSort : Array.isArray(route.query.sort) ? route.query.sort[0] : route.query.sort;
            sortFacet = getSortCriteria(sortLabel);
            productSorting.value = getProductSorting(sortLabel);
            _context.next = 6;
            return attraqtSearch({
              query: (_route$params$term = route.params.term) !== null && _route$params$term !== void 0 ? _route$params$term : '',
              options: {
                limit: 18,
                offset: (currentPage.value - 1) * 18,
                filter: ['kind=product', priceFilter.value].join(' '),
                facets: [].concat(_toConsumableArray(Object.entries(facets.value).flatMap(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];
                  if (Array.isArray(value) && value.length === 0 || key === 'type') return [];
                  if (key === 'categories') return [{
                    id: 'facet-mainCategory',
                    values: value
                  }];
                  if (key === 'available-in-countries') return [{
                    id: 'facet-availableInCountries',
                    values: value
                  }];
                  return [{
                    id: "facet-".concat(key),
                    values: value
                  }];
                })), [{
                  id: 'facet-isMasterVariant',
                  values: ['true']
                }]),
                sortBy: [sortFacet]
              }
            });
          case 6:
            // Object.assign is required here to change the reference of the object for reactivity purposes.
            searchData.value = Object.assign({}, attraqtResult.value);

            // Prevent sort changes from triggering
            // unnecessary page rerender
            newProductPagination = getProductPagination(searchData.value);
            if (!oldSort || oldSort === sortLabel || newProductPagination.count !== productPagination.value.count) {
              productPagination.value = newProductPagination;
              productFacets.value = getProductFacets(searchData.value);
            }
            if (route.params.term !== ((_searchData$value2 = searchData.value) === null || _searchData$value2 === void 0 ? void 0 : (_searchData$value2$in = _searchData$value2.input) === null || _searchData$value2$in === void 0 ? void 0 : _searchData$value2$in.query)) {
              productCategories.value = (_searchData$value3 = searchData.value) === null || _searchData$value3 === void 0 ? void 0 : (_searchData$value3$da = _searchData$value3.data) === null || _searchData$value3$da === void 0 ? void 0 : (_searchData$value3$da2 = _searchData$value3$da.metadata.facets.find(function (f) {
                return f.attribute === 'mainCategory';
              })) === null || _searchData$value3$da2 === void 0 ? void 0 : _searchData$value3$da2.values.map(function (v) {
                return {
                  id: kebabCase(v.value),
                  label: v.value,
                  count: v.count
                };
              });
            }
            slugs = searchData === null || searchData === void 0 ? void 0 : (_searchData$value4 = searchData.value) === null || _searchData$value4 === void 0 ? void 0 : (_searchData$value4$da = _searchData$value4.data) === null || _searchData$value4$da === void 0 ? void 0 : (_searchData$value4$da2 = _searchData$value4$da.items) === null || _searchData$value4$da2 === void 0 ? void 0 : _searchData$value4$da2.map(function (item) {
              return item.product.url;
            });
            if (!slugs.length) {
              _context.next = 17;
              break;
            }
            _context.next = 14;
            return search({
              filters: _defineProperty({}, "slug_".concat(locale), slugs),
              sort: 'latest',
              page: 1,
              perPage: 18,
              customerGroupId: (_user$value = user.value) === null || _user$value === void 0 ? void 0 : (_user$value$customerG = _user$value.customerGroup) === null || _user$value$customerG === void 0 ? void 0 : _user$value$customerG.id
            });
          case 14:
            // Object.assign is required here to change the reference of the object for reactivity purposes.
            commercetoolsData.value = Object.assign({}, productResults.value);
            _context.next = 18;
            break;
          case 17:
            commercetoolsData.value = null;
          case 18:
            return _context.abrupt("return", commercetoolsData.value);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _searchProducts.apply(this, arguments);
  }
  var products = computed(function () {
    var _searchData$value$dat, _searchData$value, _searchData$value$dat2, _searchData$value$dat3;
    if (!commercetoolsData.value) {
      return [];
    }
    var slugs = (_searchData$value$dat = (_searchData$value = searchData.value) === null || _searchData$value === void 0 ? void 0 : (_searchData$value$dat2 = _searchData$value.data) === null || _searchData$value$dat2 === void 0 ? void 0 : (_searchData$value$dat3 = _searchData$value$dat2.items) === null || _searchData$value$dat3 === void 0 ? void 0 : _searchData$value$dat3.map(function (item) {
      return item.product.url;
    })) !== null && _searchData$value$dat !== void 0 ? _searchData$value$dat : [];
    var variants = getVariants(commercetoolsData.value);
    var sortedVariants = slugs.flatMap(function (slug) {
      var item = variants.find(function (variant) {
        return variant._slug === slug;
      });
      return item ? [item] : [];
    });
    return sortedVariants.sort(function (p1, p2) {
      return +isAllProductVariantsOOS(p1) - +isAllProductVariantsOOS(p2);
    });
  });

  /**
   * Computes available facets based on the `productListing` data.
   *
   * @param      {SearchData}  productListing  The recipe listing
   * @return     {Facet[]}     The recipe facets.
   */
  function getProductFacets(productListing) {
    var _productListing$data, _productListing$data$, _propertyFacets$subfa, _problemFacets$subfac, _productCategories$va;
    var facets = productListing === null || productListing === void 0 ? void 0 : (_productListing$data = productListing.data) === null || _productListing$data === void 0 ? void 0 : (_productListing$data$ = _productListing$data.metadata) === null || _productListing$data$ === void 0 ? void 0 : _productListing$data$.facets.flatMap(function (facet) {
      var _facet$values, _facet$values2;
      if (!((_facet$values = facet.values) !== null && _facet$values !== void 0 && _facet$values.length)) return [];
      return [{
        id: facet.attribute,
        label: translate("search.filters.".concat(facet.attribute)),
        options: (_facet$values2 = facet.values) === null || _facet$values2 === void 0 ? void 0 : _facet$values2.map(function (value) {
          return {
            count: value.count,
            id: value.value
          };
        })
      }];
    });
    var result = [];
    var propertyFacets = {
      id: 'properties',
      label: translate('search.filters.properties'),
      type: 'nested',
      subfacets: []
    };
    var problemFacets = {
      id: 'problems',
      label: translate('search.filters.problems'),
      type: 'nested',
      subfacets: []
    };
    facets === null || facets === void 0 ? void 0 : facets.forEach(function (facet) {
      var _facet$options, _facet$options2, _facet$options3;
      if (!((_facet$options = facet.options) !== null && _facet$options !== void 0 && _facet$options.length)) return;
      if (/^problematiques-/.test(facet.id) && (_facet$options2 = facet.options) !== null && _facet$options2 !== void 0 && _facet$options2.length) {
        problemFacets.subfacets.push(facet);
      } else if (/^proprietes-/.test(facet.id) && (_facet$options3 = facet.options) !== null && _facet$options3 !== void 0 && _facet$options3.length) {
        propertyFacets.subfacets.push(facet);
      } else {
        result.push(facet);
      }
    });
    if ((_propertyFacets$subfa = propertyFacets.subfacets) !== null && _propertyFacets$subfa !== void 0 && _propertyFacets$subfa.length) result.push(propertyFacets);
    if ((_problemFacets$subfac = problemFacets.subfacets) !== null && _problemFacets$subfac !== void 0 && _problemFacets$subfac.length) result.push(problemFacets);
    if ((_productCategories$va = productCategories.value) !== null && _productCategories$va !== void 0 && _productCategories$va.length) {
      result.push({
        id: 'categories',
        label: translate('search.filters.category'),
        options: productCategories.value,
        defaultOpened: true
      });
    }
    var priceFacet = {
      id: 'price',
      label: translate('search.filters.price'),
      type: 'range',
      options: {
        min: 0,
        max: 100,
        unit: '€'
      }
    };
    result.push(priceFacet);
    var facetOrder = ['categories', 'adapte-pour', 'properties', 'problems', 'type-de-peaux', 'type-de-cheveux', 'culture', 'univers-olfactif', 'price'];
    return facetOrder.flatMap(function (facetId) {
      var facet = result.find(function (facet) {
        return facet.id === facetId;
      });
      return facet ? [facet] : [];
    });
  }

  /**
   * Gets the recipe pagination.
   *
   * @param      {SearchData}  productListing  The product listing
   * @return     {Pagination}  The product pagination.
   */
  function getProductPagination(productListing) {
    var _productListing$data2;
    var searchMeta = productListing === null || productListing === void 0 ? void 0 : (_productListing$data2 = productListing.data) === null || _productListing$data2 === void 0 ? void 0 : _productListing$data2.metadata;
    if (!searchMeta) return null;
    return {
      count: searchMeta.count,
      pages: Math.ceil(searchMeta.count / searchMeta.limit),
      current: currentPage.value
    };
  }
  var sortingOptions = [{
    type: 'sort',
    id: 'pertinence',
    value: 'sort.pertinence',
    sortCriteria: {}
  }, {
    type: 'sort',
    id: 'latest',
    value: 'sort.latest',
    sortCriteria: {
      attribute: 'ctCreatedAt',
      order: 'asc'
    }
  }, {
    type: 'sort',
    id: 'oldest',
    value: 'sort.oldest',
    sortCriteria: {
      attribute: 'ctCreatedAt',
      order: 'desc'
    }
  }, {
    type: 'sort',
    id: 'bestseller',
    value: 'sort.bestsellers',
    sortCriteria: {
      attribute: 'best-seller',
      order: 'asc'
    }
  }, {
    type: 'sort',
    id: "name-asc-lang_".concat(locale),
    value: 'sort.nameAsc',
    sortCriteria: {
      attribute: 'name',
      order: 'asc'
    }
  }, {
    type: 'sort',
    id: "name-desc-lang_".concat(locale),
    value: 'sort.nameDesc',
    sortCriteria: {
      attribute: 'name',
      order: 'desc'
    }
  }, {
    type: 'sort',
    id: 'price-asc',
    value: 'sort.priceAsc',
    sortCriteria: {
      attribute: 'displayVariantPriceEU',
      order: 'asc'
    }
  }, {
    type: 'sort',
    id: 'price-desc',
    value: 'sort.priceDesc',
    sortCriteria: {
      attribute: 'displayVariantPriceEU',
      order: 'desc'
    }
  }];

  /**
   * Gets the sort criteria.
   *
   * @param      {string}  sort    The sort
   * @return     {SortCriteria}  The sort criteria.
   */
  function getSortCriteria(sort) {
    var _sortingOptions$find$, _sortingOptions$find;
    var DEFAULT_SORT_CRITERIA = sortingOptions[0].sortCriteria;
    return (_sortingOptions$find$ = (_sortingOptions$find = sortingOptions.find(function (option) {
      return option.id === sort;
    })) === null || _sortingOptions$find === void 0 ? void 0 : _sortingOptions$find.sortCriteria) !== null && _sortingOptions$find$ !== void 0 ? _sortingOptions$find$ : DEFAULT_SORT_CRITERIA;
  }

  /**
   * Gets the recipe sorting.
   *
   * @param      {string}  sort    The sort
   * @return     {Object}  The recipe sorting.
   */
  function getProductSorting(sort) {
    return {
      options: [].concat(sortingOptions),
      selected: sort !== null && sort !== void 0 ? sort : 'pertinence'
    };
  }
  return {
    searchProducts: searchProducts,
    products: products,
    productSorting: productSorting,
    productPagination: productPagination,
    productFacets: productFacets,
    productCategories: productCategories
  };
}